import React from "react";
import { Route } from "react-router-dom";
import { PartnerQuotaCard } from "./PartnerQuotaCard";
import { PartnerQuotaEditDialog } from "./partner-quota-edit-dialog/PartnerQuotaEditDialog";
import { PartnerQuotaUIProvider } from "./PartnerQuotaUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export function PartnerQuotaPage({ history }) {
  const partnerQuotaUIEvents = {
    newPartnerQuotaButtonClick: () => {
      history.push("/kurban/quota-partner/new");
    },
    openEditPartnerQuotaPage: (partner_uuid, livestock_uuid, area_uuid) => {
      history.push(`/kurban/quota-partner/history?partner=${partner_uuid}&livestock=${livestock_uuid}&area=${area_uuid}`);
    },
  };

  return (
    <PartnerQuotaUIProvider partnerQuotaUIEvents={partnerQuotaUIEvents}>
      <PartnerQuotaCard />
    </PartnerQuotaUIProvider>
  );
}
